export class LimesurveyConfigModel {
    id: string;
    pathname: string;
    url: string;
    title: string;
    firstShowUpTimeInSeconds: number;
    showUpTimeAgainInSeconds: number;
}

export class LimeSurveyLocalStorageSetting {
    pathname: string;
    submitted: boolean;
}

function getLimesurveyConfigModels(): Array<LimesurveyConfigModel> {
    const environment: string = window.ETDR_RD.appConfig["Constants.Environment"];
    let limeSurveyConfig: Array<LimesurveyConfigModel> = window.ETDR_RD.appConfig["Config.LimeSurveyConfig"];

    if (limeSurveyConfig) {
        limeSurveyConfig.forEach((element) => {
            const url: URL = new URL(element.url);

            url.searchParams.append('lang', 'hu');
            url.searchParams.append('env', environment);
            element.url = url.toString();
        });
    }

    return limeSurveyConfig;
}

export function getLimesurveyConfigModelForCurrentPage(): LimesurveyConfigModel {
    let currentPathname = window.location.pathname;

    let configModels = getLimesurveyConfigModels();

    if (configModels && configModels.length > 0) {
        return configModels.find(model => currentPathname.includes(model.pathname));
    }

    return undefined;
}
